import {
  FindingsWebhookPostRequest,
  FindingType,
  useStartConversationLazyQuery,
} from "~/operations";
import { getError } from "~/lib/handle-error";
import { enqueueSnackbar } from "notistack";
import { ConversationProperties } from "./types";
import { upperFirst } from "lodash-es";

const transformFindingType = (
  type: string,
): FindingsWebhookPostRequest["type"] => {
  if (!type) {
    throw new Error("Invalid type argument.");
  }

  switch (type.toLowerCase()) {
    case "advisoryfinding":
      return FindingType.Advisory;
    //   return FindingType.AppPackage;
    case "checkfinding":
      return FindingType.Check;
    case "cvefinding":
      return FindingType.Cve;
    //   return FindingType.OsPackage;
    //   return FindingType.Package;
  }

  throw new Error("No matching finding to start conversation.");
};

export function useConversationStarter() {
  const [startConversationHook, { error, loading }] =
    useStartConversationLazyQuery();

  const startConversation = async ({
    scope,
    findingMrn,
    findingType,
  }: ConversationProperties) => {
    const type = transformFindingType(findingType);

    try {
      await startConversationHook({
        variables: {
          input: { findingMrn, scopeMrn: scope.mrn, type },
        },
        onCompleted: (data) => {
          const findingName = data.createFindingsWebhookPost?.status
            ?.split("/")
            .pop();
          let message = "Started conversation in Slack.";
          if (findingName) {
            message = `Started conversation in Slack about ${upperFirst(type)} ${findingName}`;
          }
          enqueueSnackbar(message, { variant: "success" });
        },
        onError: (error) => {
          enqueueSnackbar(error.message, { variant: "error" });
        },
      });
    } catch (e) {
      const error = getError(e);
      enqueueSnackbar(error, { variant: "error" });
    }
  };

  return {
    startConversation,
    conversationLoading: loading,
    conversationError: error,
  };
}
